<ng-template #modal let-modal>
  <div [ngClass]="'exit-intent-content ' + variant">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="row">
      <div class="col-12">
        <div class="modal-header d-flex align-items-center">
          <div class="row">
            <div class="col-12 mb-4">
              <img alt="Header" [src]="'/assets/img/exit-intent/' + variant + '.svg'" />
            </div>
            <div class="col-12">
              <div class="modal-title h1 d-flex flex-grow">
                {{ 'exit-intent.' + variant + '.header' | transloco }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="modal-body">
          <p>
            {{ 'exit-intent.' + variant + '.text' | transloco }}
          </p>
          <web-design-system-button (click)="continue()" [fullwidth]="true">
            {{ 'exit-intent.' + variant + '.button-label' | transloco }}
          </web-design-system-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
